<template>
  <div class="corporate-payment-upload">
    <el-upload
      v-if="!newArr.length"
      class="upload-demo"
      ref="upload"
      :action="fileUrl + '/res/attach/upload'"
      :data="paramsupload"
      :withCredentials="true"
      :show-file-list="false"
      :disabled="uploadHandling"
      :before-upload="beforeUpload"
      :on-error="handleError"
      :on-success="handleSuccess"
      :accept="acceptType"
      :multiple="multipleFlag"
      :limit="totalNum"
      :on-exceed="handleExceed"
      :on-progress="handleProgress"
      :file-list="newArr"
    >
      <div>上传转账凭证</div>
    </el-upload>
    <!-- 图片格式展示 -->
    <!-- <ul
      class="imageFormats"
      :style="'margin-bottom: 6px;'"
      v-if="uploadUlImage"
    >
      <li
        style="display: inline-block; vertical-align: middle"
        v-for="(item, index) in newArr"
        :key="index"
      >
        <div
          v-if="getFileType(item)"
          v-loading="item.progress !== 100"
          @click="preview(item)"
          style="
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            border: 1px solid #dddddd;
          "
        >
          <img
            v-if="item.hashCode"
            :src="`${fileUrl}/res/attach/preview-temp?code=${item.hashCode}&thn=S`"
            alt=""
            style="max-height: 100%; max-width: 100%"
          />
          <i
            class="el-icon-error"
            @click.stop="delFile(index)"
            style="position: absolute; top: -5px; right: -5px"
          ></i>
        </div>
      </li>
    </ul> -->
    <!-- 其他格式展示 -->
    <!-- <ul class="otherFormats" v-if="isOtherFormats">
      <li
        v-for="(item, index) in newArr"
        :key="index"
        @mouseover="changeFilehidden(index)"
        @mouseout="changeFileshow()"
        v-show="!getFileType(item)"
      >
        <div v-if="!getFileType(item)">
          <a
            :href="fileUrl + '/res/attach/download-temp?code=' + item.hashCode"
          >
            <span>{{ item.originalName }}</span>
          </a>
          <span
            v-if="!item.show && item.progress === 100"
            class="el-icon-success"
          ></span>
          <span
            v-if="item.show && item.progress === 100"
            class="el-icon-error"
            @click="delFile(index)"
          ></span>
          <el-progress
            v-if="item.progress < 100"
            :percentage="item.progress"
          ></el-progress>
        </div>
      </li>
    </ul>
    <el-image-viewer
      class="customer-follow-image-viewer"
      v-if="dialogVisible"
      :on-close="() => (dialogVisible = false)"
      :url-list="imgList"
      :initialIndex="initialIndex"
    /> -->
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { fileUrl } from '@/utils/config.js'
import {saveReceipt} from '@/utils/api/order'
export default {
  name: 'UploadArchivedFile',
  components: {
    ElImageViewer,
  },
  data() {
    return {
      accept: '',
      fileUrl,
      imgList: [],
      initialIndex: 0,
      dialogVisible: false,
    }
  },
  computed: {
    newArr() {
      return this.fileListArr
    },
    uploadUlImage() {
      return (
        this.newArr &&
        this.newArr.length &&
        this.newArr.findIndex((ele) => this.getFileType(ele)) !== -1
      )
    },
    isOtherFormats() {
      return (
        this.newArr &&
        this.newArr.length &&
        this.newArr.findIndex((ele) => !this.getFileType(ele)) !== -1
      )
    },
  },
  props: {
    //转账凭证订单号
    receiptOrderNo: {
      type: String,
      default: '',
    },
    uploadtip: {
      type: String,
      default: '',
    },
    // 附件格式
    acceptType: {
      type: String,
    },
    uploadHandling: {
      type: Boolean,
      default: false,
    },
    // 附件列表
    fileListArr: {
      type: Array,
      default: [],
    },
    // 最大上传数量
    totalNum: {
      type: Number,
      default: 0,
    },
    paramsupload: {
      type: Object,
      default: {},
    },
    // 附件大小
    size: {
      type: Number,
      default: 50,
    },
    // 数量提示
    maxFiles: {
      type: String,
    },
    // size提示
    flieSize: {
      type: String,
    },
    needInvoice: {
      type: Boolean,
      default: false,
    },
    // 是否支持多选(默认支持)
    multipleFlag: {
      default: true,
      type: Boolean,
    },
    recordsFlag: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 保存对公支付回执
    saveReceipt(val){
      const params = {
          orderNo: this.receiptOrderNo,
          hashCode: val
      }
      saveReceipt(params)
      .then(res => {
        if(res.rspResult.bizCode==200){
          console.log('保存对公支付Success');
          this.$router.push('my-order')
          // this.$emit('getOrderList')

          console.log('----------');

        }
      })
      .catch(err => {
        console.log('保存对公支付失败',err);
      })

    },
    handleExceed() {
      this.$message.warning(this.maxFiles)
    },
    beforeUpload(file) {
      this.$emit('changeFileList', this.newArr, true)
      let name = file.name ? file.name : ''
      let ext = name
        ? name.substr(name.lastIndexOf('.') + 1, name.length)
        : true
      ext = ext.toLowerCase()
      let isExt = this.acceptType.indexOf(ext) < 0
      if (isExt) {
        this.$message.error('请上传正确的格式')
        return false
      }
      const isLt100M = file.size / 1024 / 1024
      if (isLt100M > this.size) {
        this.$message.error(this.flieSize)
        this.$emit('changeFileList', this.newArr, false)
        return false
      }
      const obj = {
        originalName: file.name,
        progress: 0,
        code: 200,
        uid: file.uid,
      }
      // this.newArr = JSON.parse(JSON.stringify(this.fileListArr));
      this.newArr.push(obj)
      return true
    },
    /***
     * 文件上传失败删除该项
     */
    handleError(err, file, fileList) {
      this.newArr.pop()
      this.$emit('changeFileList', this.newArr, false)
      this.$message.error('上传失败，请稍后再试')
    },
    /***
     * 文件上传中，上传进度条
     */
    handleProgress(event, file, fileList) {
      if (!file) {
        return this.newArr.pop()
      }
      let progress = Math.floor(event.percent)
      this.newArr.forEach((item, index) => {
        let obj = item
        if (obj.uid == file.uid) {
          obj.progress = progress === 100 ? 99 : progress
          this.$set(this.newArr, index, obj)
        }
      })
    },
    /***
     * 文件上传成功
     */
    handleSuccess(response, file, fileList) {
      if (response.rspResult.bizCode !== 200) {
        this.newArr.pop()
        this.$message.error(response.rspResult.message)
      } else if (response.rspResult.bizCode === 200) {
        
        const data = response.data
        let compile = false
        this.newArr.forEach((item, index) => {
          let obj = item
          if (obj.uid == file.uid) {
            obj.hashCode = data.hashCode
            obj.url = data.url
            obj.previewUrl = data.previewUrl
            obj.show = true
            obj.code = 200
            obj.progress = 100
            this.$set(this.newArr, index, obj)
            console.log('this.newArr',this.newArr);
            console.log('success,上传成功');
            this.saveReceipt(data.hashCode)
          }
          // if (obj.progress !== 100) {
          //   compile = true
          // }
        })
        // this.changeFileshow()
        // this.$emit('changeFileList', this.newArr, compile)
      }
    },
    changeFileshow() {
      this.newArr.forEach((item, index) => {
        let obj = item
        obj.show = false
        this.$set(this.newArr, index, obj)
      })
    },
    delFile(val) {
      this.newArr.splice(val, 1)
      this.$emit('changeFileList', this.newArr, false)
    },
    changeFilehidden(val) {
      this.newArr.forEach((item, index) => {
        let obj = item
        if (val == index) {
          obj.show = true
        } else {
          obj.show = false
        }
        this.$set(this.newArr, index, obj)
      })
    },
    getFileType(item) {
      const name = item.originalName ? item.originalName : ''
      const ext = name
        ? name.substr(name.lastIndexOf('.') + 1, name.length)
        : true
      let arr = ['png', 'jpg', 'jpeg']
      const isExt = arr.includes(ext.toLowerCase())
      return isExt
    },
    preview(val) {
      this.getImgList(val)
      this.dialogVisible = true
    },
    getImgList(val) {
      this.imgList = []
      this.newArr.forEach((item) => {
        if (this.getFileType(item)) {
          if (item.hashCode) {
            this.imgList.push(
              `${this.fileUrl}/res/attach/preview-temp?code=${item.hashCode}`
            )
            console.log('--------',this.imgList);
          }
        }
      })
      this.imgList.forEach((item, index) => {
        if (
          item ===
          `${this.fileUrl}/res/attach/preview-temp?code=${val.hashCode}`
        ) {
          this.initialIndex = index
        }
      })
      this.unique()
    },
    unique() {
      this.imgList = Array.from(new Set(this.imgList))
    },
  },
}
</script>

<style lang="scss" scoped>
.corporate-payment-upload {
  // margin-bottom: 15px;
  .upload-demo {
    // margin-bottom: 10px;
  }
  ::v-deep .el-button {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066eb7;
    padding: 0;
    span {
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
  .otherFormats {
    width: 308px;
    overflow: hidden;
    padding-left: 0;
    li {
      width: 100%;
      overflow: hidden;
      margin-top: 10px;
      line-height: 16px;
      a {
        overflow: hidden;
        float: left;
        font-size: 12px;
        color: #066eb7;
        letter-spacing: 0;
        padding-right: 10px;
        span {
          float: left;
          margin-right: 5px;
          max-width: 260px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 12px;
        }
      }
      span {
        float: right;
        margin-top: 1px;
      }
      .el-icon-success {
        float: right;
        margin-top: 2px;
        color: #49d618;
      }
      .el-icon-error {
        float: right;
        margin-top: 2px;
        color: #f56c6c;
        cursor: pointer;
      }
    }
    li:hover {
      background: rgba(0, 0, 0, 0.075);
      a {
        color: #066eb7;
      }
    }
  }
  .imageFormats {
    padding-left: 0;
    li {
      cursor: pointer;
      margin-left: 5px;
      .el-icon-error {
        z-index: 2001;
      }
      .el-icon-error:hover {
        color: #f56c6c;
      }
    }
  }
  .click-area {
    width: 280px;
    height: 110px;
    border: 1px dashed #cfd5df;
    border-radius: 4px;
    padding-top: 24px;
    box-sizing: border-box;
    i {
      font-size: 16px;
      color: #4f5d78;
    }
    div {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #066eb7;
      margin: 12px 0 8px 0;
      height: 14px;
      line-height: 14px;
    }
    p {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #98a3b7;
      height: 12px;
      line-height: 12px;
    }
  }
}
.customer-follow-image-viewer {
  z-index: 99999 !important;
}
</style>
